import { Link } from "react-router-dom";
import { REQUIREMENTS } from "./catalog";

export const SubscriptionRequirement = ({ feature, className = "" }) => (
  <div className={`rbr-feature-requirement ${className}`.trim()}>
    <span className={feature.requirement === "texting" ? "secondary" : undefined}>{feature.requirement === "confirm" ? REQUIREMENTS.confirm : `Requires ${REQUIREMENTS[feature.requirement]}`}</span>
    {feature.paidAddon && <span className="rbr-feature-badge">Paid add-on</span>}
  </div>
);

export const FeatureAction = ({ feature, account }) => (
  feature.admin && Number(account?.user?.owner_id) > 0
    ? <span className="rbr-feature-admin">Ask your account administrator to set this up.</span>
    : <Link className="uk-button hms-btn hms-red-btn uk-flex-inline uk-flex-middle" to={feature.path}>{feature.action}</Link>
);
